import React from 'react';

export default function Page404() {
  return (
    <main className="not-found">
      <div className="not-found__card">
        <p className="section-eyebrow">404</p>
        <h1>Nothing lives here yet.</h1>
        <p>
          The page you are looking for could not be found. Head back to the main profile and we will get
          you pointed in the right direction.
        </p>
        <a className="button button--primary" href="/">
          Return home
        </a>
      </div>
    </main>
  );
}
